import { Injectable } from "@angular/core";
import { FormControlStatus, FormGroup, Validators } from "@angular/forms";
import { ETransferServiceCode, IResultNavigationDetails } from "@common/models";
import { ResultService } from "@common/services";
import { TranslateService } from "@ngx-translate/core";
import { catchError, map, Observable, throwError } from "rxjs";
import { CommonService } from "src/app/common.service";
import { BaseFpxFormHelper, BaseFpxComponentState, BaseFpxChangeHandler } from "src/app/common/utils/base-fpx.form.component";
import { RetailStock } from "src/app/retail-common.service";
import { AccountsService } from "src/app/services/accounts/accounts.service";
import { BeneficiaryService } from "src/app/services/beneficiary/beneficiary.service";
import { CustomerService } from "src/app/services/customer.service";
import { TransfersService } from "src/app/services/transfers/transfers.service";
import { INewFormDataModel, IResetValueModel } from "../models/transfer-beneficiary.model";
import { TransferBeneficiaryService } from "./transfer-beneficiary.service";

export class TransferBeneficiaryState extends BaseFpxComponentState {
    activeFromAccountNumber: string;
    selectedBene: any;
    showScheduledInfo: boolean;
    amountAfterDebit: string;
    amountAfterCredit: string;
    allowScheduleTransfer: boolean;
    paymentSystem: string = 'INTBT';
    beneDetails;
    isForm = true;
    showLoanInstallmentSchedule: boolean = false;
    fromAccountNumber: string = '';
    errorType = 'error';
    beneId: string;
    formGroupValue: any;
    favDisable: boolean;
    resetValues: IResetValueModel;
    hideRemarks: boolean;
    newFormData: INewFormDataModel;
    selectableCurrencyList;
    isnoMoreBeneAvailable: boolean = false;
    isComponentInitialLoad: boolean = true;
    disableMode: boolean;
}

@Injectable()
export class TransferBeneficiaryHelper extends BaseFpxFormHelper<TransferBeneficiaryState> {
    constructor(private transferBeneficiaryService: TransferBeneficiaryService,
        public _beneficiaryService: BeneficiaryService,
        public accountsService: AccountsService,
        public _commonService: CommonService,
        public customerService: CustomerService,
        public transferService: TransfersService,
        private _resultService: ResultService,
        public translate: TranslateService,
        private _retailStock: RetailStock) {
        super(new TransferBeneficiaryState());
        this.addChangeHandler("debitAccNo", this.doDebitAccNoChange);
        this.addChangeHandler("isScheduled", this.doScheduledChange);
        this.addChangeHandler("amount", this.doAmountChange);
        this.addChangeHandler("beneId", this.dobeneIdChange);
    }
    private dobeneIdChange: BaseFpxChangeHandler = (name: string, status: FormControlStatus, value: any, formGroup: FormGroup) => {
        if (value) {
            this.state.selectedBene = value.selectedBene
            this.state.beneId = value.beneId
            this.state.beneDetails = value.selectedBene

        } else if (value == '') {

        }
        this.setTitle()
    }

    setTitle() {
        this.transferService.setTitle(['home', 'transfers'], true, this.translate.instant('PAYMENTDETAILS.' + this.state.paymentSystem));
    }

    private doAmountChange: BaseFpxChangeHandler = (name: string, status: FormControlStatus, value: any, formGroup: FormGroup) => {
    }
    private doDebitAccNoChange: BaseFpxChangeHandler = (name: string, status: FormControlStatus, value: any, formGroup: FormGroup) => {
        if (!this.state.isComponentInitialLoad) {
            formGroup.get('amount').reset('', { emitEvent: false });
        }
        if (value) {
            this.setCurrencyDropDown(value);
            this.state.activeFromAccountNumber = value;
        } else {
            this.state.activeFromAccountNumber = '';
        }
    }
    private doScheduledChange: BaseFpxChangeHandler = (name: string, status: FormControlStatus, value: any, formGroup: FormGroup) => {
        if (value == '1') {
            this.state.showScheduledInfo = true;
            formGroup.controls['scheduleType'].enable();
            formGroup.controls['noOfInstallment'].enable();
            formGroup.controls['endDate'].enable();

            formGroup.controls['scheduleType'].setValidators([Validators.required]);
            formGroup.controls['noOfInstallment'].setValidators([Validators.required]);
            formGroup.controls['endDate'].setValidators([Validators.required]);


        } else {
            formGroup.controls['scheduleType'].disable();
            formGroup.controls['noOfInstallment'].disable();
            formGroup.controls['endDate'].disable();
            this.state.showScheduledInfo = false;

            formGroup.controls['scheduleType'].clearValidators();
            formGroup.controls['noOfInstallment'].clearValidators();
            formGroup.controls['endDate'].clearValidators();

        }
    }
    getPaymentKeyByType(paymentSystem) {
        switch (paymentSystem) {
            case 'INTBT': return 'paymentaccount'
            case 'SWIFT': return 'paymentswift'
            // case 'SEPA': return 'paymentsepa',
            case 'ACH': return 'paymentach'
            case 'PAYMENTACH': return 'paymentach'
            case 'PAYMENTSWIFT': return 'paymentswift'
        }
    }
    getBeneKeyByType(paymentSystem) {
        switch (paymentSystem) {
            case 'INTBT': return 'beneAccount'
            case 'SWIFT': return 'beneSWIFT'
            // case 'SEPA': return 'beneSEPA',
            case 'ACH': return 'beneACH'

        }
    }

    getServiceCode(paymentSystem) {
        switch (paymentSystem) {
            case 'INTBT': return ETransferServiceCode.INTBT_TRANSFER
            case 'SWIFT': return ETransferServiceCode.SWIFT_TRANSFER
            case 'ACH': return ETransferServiceCode.ACH_TRANSFER
        }
    }


    filterEGPForSwift(){
        let accountList = this.customerService?.getAccount('ALL');
        if (this.state.paymentSystem != 'SWIFT') {
          if (!this.state.fromAccountNumber && accountList.length != 0) this.state.fromAccountNumber = accountList[0]?.accountNumber;
        }
    
        if (accountList && accountList.length != 0 && this.state.paymentSystem == 'SWIFT') {
          let swiftAccounts = accountList.filter(x => {
            return x.accountCurrency != 'EGP'
          })
          let routParamFromAccountDetail = false;;
          if (this.state.fromAccountNumber) {
            accountList.forEach(x => {
              if (x.accountNumber == this.state.fromAccountNumber && x.accountCurrency != 'EGP') {
                routParamFromAccountDetail = true
              }
            })
          }
          this.state.fromAccountNumber = routParamFromAccountDetail ? this.state.fromAccountNumber
            : swiftAccounts && swiftAccounts.length != 0 ? swiftAccounts[0].accountNumber : '';
        }
    }

    setUpBeneficiaryDetails(paymentSystem, beneId) {
        this._beneficiaryService.getBeneObservableListByType(paymentSystem).subscribe(res => {
            if (res && res.length > 0) {
                if (res.length == 1) this.state.isnoMoreBeneAvailable = true;
                this.state.beneDetails = this.state.selectedBene;
            } else {
                this.state.beneDetails = this.state.selectedBene;
            }
        })
    }

    enableOrDisableSchedule() {
        if (this._retailStock.paymentMethodData) {
            for (let item of this._retailStock.paymentMethodData) {
                if (item.isAdhoc == '0' && item.system == this.state.paymentSystem) {
                    this.state.allowScheduleTransfer = false;
                    break
                }
            }
        }

    }

    compareWithExistForm(currentFormData, previousFormData) {
        return this.transferService.compareWithExistForm(currentFormData, previousFormData);
    }

    setCurrencyDropDown(accountNumber) {
        if (accountNumber) {
            if (this.state.paymentSystem == 'SWIFT') {
                if (accountNumber) {
                    let fromAccountDetail = this.accountsService.getAccountSummaryData(accountNumber)
                    this.state.selectableCurrencyList = [fromAccountDetail.accountCurrency];
                }
            } else {
                let fromAccountDetail = this.accountsService.getAccountSummaryData(accountNumber);
                this.state.selectableCurrencyList = [];
                if (fromAccountDetail.accountCurrency == 'EGP') {
                    this.state.selectableCurrencyList = [fromAccountDetail.accountCurrency];
                } else {
                    const selectedAcc = this.customerService.getAccount('ALL');
                    this.state.selectableCurrencyList.push(fromAccountDetail.accountCurrency)
                    selectedAcc.forEach(res => {
                        if (fromAccountDetail.accountCurrency != res.accountCurrency && fromAccountDetail.accountNumber != res.accountNumber) {
                            this.state.selectableCurrencyList.push(res.accountCurrency)
                        }
                    })
                    this.state.selectableCurrencyList = [fromAccountDetail.accountCurrency, 'EGP'];
                }
            }
        }
    }

    setUpResutPageData(isSuccess, response, resultData, formGroupData) {
        let beneDetails = this.state.beneDetails
        let beneKey = this.getBeneKeyByType(this.state.paymentSystem);
        let paymentKey = this.getPaymentKeyByType(this.state.paymentSystem);
        if (isSuccess) {

            let additionalFields = {
                'referenceNumber': response?.refNo,
                'beneName': beneDetails?.beneName,
                'fromAccountNumber': resultData.debitAccNo,
                'toAccountNumber': beneDetails?.accNo ? beneDetails?.accNo : beneDetails?.iban,
                'amount': this._commonService.formatAmount(resultData.amount.amount,) + ' ' + resultData.amount.currencyCode,
                'beneId': this.state.beneId,

            };
            let basepath = this._commonService.isMobile() ? 'shell' : 'home'
            let additionalNavigation: IResultNavigationDetails[] = [
                {

                    path: ["home", 'transfers', 'new-payment'],
                    queryParams: {
                        additionalDetails: { "fromNav": "payment", "closeNav": ["home", "transfers"] },
                        beneId: this.state.newFormData?.beneId,
                        referenceKey: this.state.newFormData?.referenceKey,
                        paymentType: this.state.beneId
                    },
                    btnLabel: this.translate.instant('FORM_ACTIONS.newPayment'),
                    btnType: 'primary',
                }
            ];
            let isAlreadyFav = this.compareWithExistForm({ 'debitAccNo': resultData.debitAccNo, 'beneId': resultData.beneId, amount: resultData.amount, remarks: resultData.remarks }, this.state.resetValues);
            let hiddenData = { 'enableFav': !isAlreadyFav ? true : false, "referenceNumber": response?.refNo, "beneId": resultData.beneId, "accNo": resultData.debitAccNo, "beneName": beneDetails?.beneName, "paymentMethod": this.state.paymentSystem };
            let servicecode = this.getServiceCode(this.state.paymentSystem);
            this._resultService.setSuccess(
                response,
                servicecode,
                additionalFields,
                additionalNavigation, '', true,
                hiddenData
            );
        } else {
            let basepath = this._commonService.isMobile() ? 'shell' : 'home'
            let additionalNavigation: IResultNavigationDetails[] = [
                {
                    path: [basepath, 'transfers', 'new-payment'],
                    queryParams: {
                        formGroupValue: formGroupData,
                        beneId: this.state.beneId,
                        referenceKey: resultData.debitAccNo,
                        paymentType: this.state.paymentSystem
                    },
                    btnLabel: 'Retry',
                    btnType: 'primary',
                }
            ];

            let additionalFields = {
                // 'beneName': beneDetails.beneName,
                // 'fromAccountNumber': resultData.debitAccNo,
                // 'toAccountNumber': beneDetails?.accNo ? beneDetails?.accNo : beneDetails?.iban,
                // 'amount': this._commonService.formatAmount(resultData.amount?.amount,) + ' ' + resultData.amount?.currencyCode,
                // 'beneId': this.state.beneId,
            };

            let servicecode = this.getServiceCode(this.state.paymentSystem);
            this._resultService.setFailure(
                response,
                false,
                servicecode + "FAILED",
                additionalFields,
                additionalNavigation, '', true,
            );
        }
    }



    fetchTransferDetails(paymentSystem, requestReference, formGroup: FormGroup) {
        let paymentKey = this.getPaymentKeyByType(paymentSystem);
        this.transferBeneficiaryService.fetchTransferDetails(paymentKey, requestReference).subscribe(
            (res) => {
                let bene =  { beneId: res.payment?.beneId, selectedBene: this.constructSelectedBene({ beneId: res.payment?.beneId, beneName: res.payment?.beneName, paymentSystem: res.payment?.paymentSystem, accNo: res.payment?.creditAccNo, iban: res?.iban, bankName: res?.bankName }) };
                this.state.selectedBene = bene
                this.state.beneDetails = bene?.selectedBene;
                let date = res.payment.transferDate.split('-');
                let formatdate = date[1] + '-' + date[0] + '-' + date[2];
                formGroup.patchValue({
                    debitAccNo: res.accNo,
                    beneId: bene,
                    amount: {
                        'amount': res.payment.debitAmount.toString(),
                        'currencyCode': res.payment.creditCurrency
                    },
                    transferDate: formatdate,
                    remarks: res.payment.remarks,
                    isScheduled: res.payment.isScheduled,
                    scheduleType: res.payment.scheduleType,
                    noOfInstallment: res.payment.noOfInstallment,
                    cancelDate: res.payment.cancelDate
                }, { emitEvent: false });
                formGroup.disable({ emitEvent: false });
                this.state.disableMode=true;
            },
            (err) => {

            }
        );
    }

    getDebitAccountDetail(debitAccNo) {
        return this.customerService?.getAccount('ALL')?.filter(x => {
            return x.accountNumber === debitAccNo
        });
    }

    public doConfirm(context: any, paymentSystem, success: any, failure: any) {
        this._commonService.showSpinner();
        let paymentKey = this.getPaymentKeyByType(paymentSystem);
        let beneKey = this.getBeneKeyByType(paymentSystem);
        let beneDetails = this.state.beneDetails;
        delete context["beneId"];
        context = {
            ...context,
            beneId: beneDetails.beneId,
            debitCurrency: this.getDebitAccountDetail(context.debitAccNo)[0]?.accountCurrency,
            debitAmount: context.amount.amount,
            creditCurrency: context.amount.currencyCode,
            paymentMethod: beneDetails.paymentSystem,
            benePhoto: beneDetails.benePhoto,
            paymentSystem: beneDetails.paymentSystem,
            source: 'UI',
            creditAccNo: beneDetails?.accNo ? beneDetails?.accNo : beneDetails?.iban,
            iban: beneDetails?.iban,
            beneName: beneDetails.beneName,
            // benePhoto: beneDetails.benePhoto
        }
        // delete beneDetails["beneficiary"];
        if (!context.iban) { delete context["iban"]; }
        delete context["amount"];
        // delete context["beneId"];

        let payload: any = {};
        payload[paymentKey] = beneDetails
        payload[paymentKey]['payment'] = { ...context };
        this.transferBeneficiaryService.transferBeneficiary(paymentKey, payload).subscribe(
            (res) => {
                this._commonService.hideSpinner();
                success(res);
            },
            (err) => {
                this._commonService.hideSpinner();
                failure(err);
            }
        );
    }

    makePaymentlimitsPayload(amount, currencyCode) {
        return {
            "servicelimits": {
                "paymentMethod": this.state.paymentSystem,
                "amount": amount,
                "currency": currencyCode
            }
        }
    }

    public fectchPaymentlimitsByPaymentSystem(context: any): Observable<any> {
        let payload = this.makePaymentlimitsPayload(context?.amount, context?.currencyCode)
        return this.transferService.fectchPaymentlimitsByPaymentSystem(payload)
    }


    public preSubmitValidation(formGroup: FormGroup): Observable<boolean> {
        this._commonService.showSpinner();
        return this.fectchPaymentlimitsByPaymentSystem(formGroup.get('amount').value).pipe(map(res => {
            this._commonService.hideSpinner();
            this.state.disableMode=true;
            this.navToConfirmPage(formGroup);
            return false
        }),
            catchError((err) => {
                this._commonService.hideSpinner();
                if (err && err?.error?.errorCode) {
                    if (err && err?.error?.errorCode == "LM000") {
                        this.navToConfirmPage(formGroup);
                    } else {
                        let errorCode = err?.error?.errorCode;
                        formGroup.get('amount').setErrors({ [errorCode]: true }, { emitEvent: true });
                        formGroup.updateValueAndValidity();
                    }
                }
                return throwError(err);
            }))
    }

    navToConfirmPage(formGroup: FormGroup) {
        formGroup.disable({ emitEvent: false });
        this.state.favDisable = true;
        this._commonService.resetPageScroll(0);
        let remarkValue = formGroup.controls['remarks'].value;
        if (remarkValue == '') {
            this.state.hideRemarks = true;
        }
        formGroup.updateValueAndValidity();
    }


    constructSelectedBene(data) {

        if (data && data != '') {
            this.state.beneId = data.beneId;
            if (data.paymentSystem == 'INTBT') {
                this.state.selectedBene = {
                    beneId: data.beneId,
                    paymentSystem: data.paymentSystem,
                    beneName: data.beneName,
                    accNo: data?.accNo,
                    benePhoto: data.benePhoto
                }

            } else if (data.paymentSystem == 'ACH') {
                this.state.selectedBene = {
                    beneId: data.beneId,
                    paymentSystem: data.paymentSystem,
                    beneName: data.beneName,
                    iban: data?.iban,
                    accNo: data?.accNo,
                    benePhoto: data.benePhoto
                }
            } else if (data.paymentSystem == 'SWIFT') {
                this.state.selectedBene = {
                    beneId: data.beneId,
                    paymentSystem: data.paymentSystem,
                    beneName: data.beneName,
                    bankName: data.bankName,
                    accNo: data?.accNo,
                    iban: data?.iban,
                    benePhoto: data.benePhoto
                }
            }
            this.state.beneDetails = this.state.selectedBene;
            return this.state.selectedBene;
        }
    }

    resetState(){
        this.state.disableMode=false;
      }
}